
import React from 'react';
import { Textarea } from '../../../../../components/ui/textarea';
import { BaseFieldPreviewProps } from './previewUtils';

const TextareaFieldPreview: React.FC<BaseFieldPreviewProps> = ({ field, renderDescription }) => {
  return (
    <div>
      {renderDescription()}
      <Textarea placeholder={field.placeholder || 'Antwortfeld für lange Antworten'} disabled className="bg-white" />
    </div>
  );
};

export default TextareaFieldPreview;
